import { useMemo } from 'react';
import styled from 'styled-components';
import { CODE_BLOCK_REGEX, PARSE_CODE_BLOCK_REGEX } from 'chatspot-core/messages/code/CodeRegex';
import Markdown from '../../components/text/Markdown';
import CodeBlock from '../../components/text/CodeBlock';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageWrapper = styled.div.withConfig({
  displayName: "HtmlSectionFormatter__MessageWrapper",
  componentId: "sc-140gm85-0"
})(["width:100%;"]);
const HtmlSectionFormatter = ({
  section: {
    text = ''
  },
  shouldShowTypingIndicator
}) => {
  const messageBlocks = useMemo(() => {
    const textBlocks = text.split(CODE_BLOCK_REGEX);
    return textBlocks.map((textBlock, index) => {
      const parsedCodeBlock = textBlock.match(PARSE_CODE_BLOCK_REGEX);
      if (parsedCodeBlock) {
        const [__fullTextBlock, language, code] = parsedCodeBlock;
        return /*#__PURE__*/_jsx(CodeBlock, {
          code: code,
          language: language
        }, index);
      }
      return /*#__PURE__*/_jsx(Markdown, {
        html: textBlock,
        showTypingIndicator: shouldShowTypingIndicator && index === textBlocks.length - 1
      }, index);
    });
  }, [shouldShowTypingIndicator, text]);
  return /*#__PURE__*/_jsx(MessageWrapper, {
    children: messageBlocks
  });
};
export default HtmlSectionFormatter;